import React, { ReactNode } from 'react';
import cn from 'classnames';
import {
  Input,
  OfferIcon,
  OfferQuantity,
  OfferDescriptionWrapper,
  RemoveButton,
} from '../../elements';
import { Offer } from '../../../types';
import OfferDescriptionContent from './OfferDescriptionContent';
import UpsellListItem from './UpsellListItem';

interface Props {
  offer: Offer;
  variantID?: number;
  cyData: string;
  upsellListItemCustomClassName: string;
  img: ReactNode;
  animatedIcon: ReactNode | null;
  loading: boolean;
  added: boolean;
  select?: (className: string) => ReactNode | null;
  primaryButton: ReactNode;
  quantity: number;
  label?: string;
  handleRemoveFromCartClick: () => Promise<void>;
  setOfferNote: (note: string) => void;
  offerNote: string;
  offerDescriptionHeading: ReactNode;
  handleOfferQuantityChange: React.Dispatch<React.SetStateAction<number>>;
  hidden?: boolean;
  id?: number;
  openDetail: () => void;
}

export const OfferBodyGrid = ({
  offer,
  cyData,
  img,
  animatedIcon,
  loading,
  added,
  select,
  handleRemoveFromCartClick,
  primaryButton,
  setOfferNote,
  offerNote,
  offerDescriptionHeading,
  quantity,
  handleOfferQuantityChange,
  upsellListItemCustomClassName,
  hidden,
  id,
  openDetail,
}: Props) => {
  const iconId = `icon-${id}-${offer.id}`;

  return (
    <UpsellListItem
      id={`${id}${offer.id}`}
      hidden={hidden}
      data-offer-id={offer.id}
      data-cy={cyData}
      className={upsellListItemCustomClassName}
    >
      <div className="upsell-list-item-left-section-grid">
        <div onClick={openDetail} className="offer-icon-wrapper-grid">
          <OfferIcon clickable id={iconId}>
            {img}
          </OfferIcon>
          {animatedIcon}
        </div>
      </div>
      <div>
        <OfferDescriptionWrapper onClick={openDetail} id={iconId}>
          {offerDescriptionHeading}

          {offer.short_description && (
            <OfferDescriptionContent>
              {offer.short_description}
            </OfferDescriptionContent>
          )}
        </OfferDescriptionWrapper>

        <div
          className={cn(
            'note-field--wrapper-grid',
            select || offer.show_note_field ? 'block' : 'hidden',
          )}
        >
          {select && select('')}
          {offer.enable_quantity_selector && (
            <OfferQuantity
              containerClasses="offer-quantity-container-grid"
              quantity={quantity}
              handleOfferQuantityChange={handleOfferQuantityChange}
              disabled={added || loading}
            />
          )}
        </div>
      </div>

      <div className="w-full offer-button-grid buy-container-grid">
        {offer.show_note_field && (
          <div className="note-field-grid">
            <Input
              disabled={added}
              value={offerNote}
              onChange={(e) => {
                setOfferNote(e.target.value);
              }}
            />
          </div>
        )}
        <div className="flex w-full">
          {primaryButton}
          {added ? (
            <RemoveButton
              disabled={loading}
              onClick={handleRemoveFromCartClick}
              className="mr-4 button-remove-grid md:mr-none"
            />
          ) : null}
        </div>
      </div>
    </UpsellListItem>
  );
};
